import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    host: { 'class': 'page-padding u-display-block' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent { }
